import { createFileRoute } from '@tanstack/react-router'
import { DeviceTable } from '../../features/devices/DeviceTable.tsx'

export const Route = createFileRoute('/_app/devices/')({ component: DeviceTable })
